export const model = {
  id: null,
  location_name: '',
  branch_id: '',
  created_at: '',
  updated_at: '',
};
